import get from "lodash.get"
import React from "react"
import { useOutletContext } from "react-router-dom"

import { EmailTemplatePreview } from "@components/Text"
import { ReadBatchOutputShape } from "@api/services/backstage"
import { PROJECT_FILE_CREATED, INVESTOR_FILE_CREATED } from "@api/services/notifications/shapes/TemplateKeyEnum"


const BatchEmailTemplatePreview = ({ batch }) => {
  const { projectTemplatesStore } = useOutletContext()
  const { getTemplateByKey } = projectTemplatesStore

  const { isSent, customHtmlTemplate, fileUrl } = batch
  const shouldNotRender = isSent && !customHtmlTemplate

  // NOTE: Do not render preview for batches that were created before the
  //       "customHtmlTemplate" attribute was introduced, as we don't know
  //       whether the template was changed after it was sent to investors.
  if (shouldNotRender) {
    return null
  }

  const templateKey = fileUrl
    ? PROJECT_FILE_CREATED
    : INVESTOR_FILE_CREATED

  const template = getTemplateByKey(templateKey)
  const { variables = [], html, subject } = template

  const htmlTemplate = get(batch, 'customHtmlTemplate', html)
  const subjectTemplate = get(batch, 'customSubjectTemplate', subject)

  return (
    <EmailTemplatePreview
      variables={variables}
      extraContext={{ batch }}
      htmlTemplate={htmlTemplate}
      subjectTemplate={subjectTemplate}
    />
  )
}

BatchEmailTemplatePreview.propTypes = {
  batch: ReadBatchOutputShape.isRequired,
}

export default BatchEmailTemplatePreview
